import DynamicSpeaker from "./components/DynamicSpeaker";

function App({mainCategory, eventDate, eventMenuLink}) {
    return (
        <DynamicSpeaker mainCategory={mainCategory} eventDate={eventDate} eventMenuLink={eventMenuLink}/>
    );
}

export default App;
